import { DocumentHeader } from '../Header/DocumentHeader'
import { ProjectDetails } from '../Editor/ProjectDetails'
import { DocumentFooter } from '../Footer/DocumentFooter'
import { DocumentFooterDescription } from '../Editor/DocumentFooterDescription'
import { Skeleton } from 'antd'
import { LineItemList } from './LineItemList'
import { useFFEStore } from '../../store/ffeStore'
import { PreviewStructure } from './PreviewStructure'

export const DocumentStructure = () => {
  const isPreviewing = useFFEStore((state) => state.isPreviewing)
  const isLoading = useFFEStore((state) => state.loadingEditor)
  if (isPreviewing) {
    return <PreviewStructure />
  }
  return (
    <div className="p-4 bg-gray-50 rounded-xl">
      <DocumentHeader />
      <Skeleton loading={isLoading}>
        <ProjectDetails />
        <LineItemList />
        <DocumentFooterDescription />
        <DocumentFooter />
      </Skeleton>
    </div>
  )
}
